import Box from '@mui/material/Box';
import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2
import Button from '@mui/material/Button';

import { useLocalStorage } from "../components/useLocalStorage";
import { useNavigate, Outlet, Link } from "react-router-dom";

const AppBoardScreen = () => {
    const [DoyouWantMakePaymentAvoidChargesHidden, setDoyouWantMakePaymentAvoidChargesHidden] = useLocalStorage("RegistrationRequireInfoHidden", "");
    const navigate = useNavigate();
    return (
        <Box id="AppBoardScreen1" className="AppBoardScreen AppBoardScreen1" sx={{ width: 800, m: "auto",  backgroundColor: '#fefefe', p: 6.25 }}>
            <input type="hidden" value={DoyouWantMakePaymentAvoidChargesHidden} />

            <Grid container spacing={2} sx={{ textAlign: "center" }}>
                <Grid item xs={12} sx={{ textAlign: "left" }}>
                    <Link to="/dmv/cambio/HaveYouDoneTheSmogYet">
                        <Button variant="outlined" size="large">Regresar</Button>
                    </Link>
                </Grid>
                <Grid item xs={12}>
                    <h2 className="subHeading">¿Quiere hacer el pago para evitar cargos?</h2>
                </Grid>
                <Grid item xs={12}>
                    <Button onClick={ () => { setDoyouWantMakePaymentAvoidChargesHidden("Yes"); setTimeout(() => { navigate("/dmv/cambio/ShippingAddress")}, 100) }} variant="contained" color="success" size="large" sx={{ width: "50%" }}>Si</Button>
                </Grid>
                <Grid item xs={12}>
                    <Button onClick={ () => { setDoyouWantMakePaymentAvoidChargesHidden("No"); setTimeout(() => { navigate("/dmv/cambio/WhatCallContinueProcessSmog")}, 100) }} variant="contained" color="error" size="large" sx={{ width: "50%" }}>No</Button>
                </Grid>
                <Outlet />

            </Grid>
        </Box>
    );
};

export default AppBoardScreen;